import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./translations/en.json";
import cy from "./translations/cy.json";

// TODO: move to sep file
const resources = {
  en,
  cy,
};

let language = "en";
const hash = window.location.hash;
if (hash) {
  let splitHash = hash.split("/");
  language = splitHash[1];
}

i18n.use(initReactI18next).init({
  resources,
  lng: language,

  keySeparator: false,

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
